import PropTypes from 'prop-types';
import { createComponent } from '../core/create-component.js';
var propTypes = {
  /**
  * Allows for a rich text formatting of the Summary, use with multiple Typography elements as children
  */
  rich: PropTypes.bool,

  /**
  * Aligns the last child element to the right. Includes the `rich` prop behavior
  */
  richLastAlign: PropTypes.string
};
var CollapsibleSummary = createComponent({
  displayName: 'CollapsibleSummary',
  root: 'div',
  propTypes: propTypes,
  propConfig: {
    classNames: function classNames(props) {
      var classNameSet = new Set(['swan-collapsible-summary']);
      if (props.rich || props.richLastAlign) classNameSet.add('swan-collapsible-summary-rich');
      if (props.richLastAlign === 'right') classNameSet.add('swan-collapsible-summary-rich-last-align-right');
      return classNameSet;
    }
  }
});
export { CollapsibleSummary };